import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { CatalogSuggestionMatchConfidence } from 'fym-shared/src/smartlinks/catalog';
import { TypedMemo } from '../../../common/types';
import { Cover } from '../../../music24/components/primitives/Cover';
import { CatalogSuggestionMatch } from '../../../../redux/api/fymAPI.types';
import { formatCatalogDay } from '../catalogDates';
import { claimWayMessages } from './claimWayMessages';
import { matchArtworkSrc } from './claimWayRules';
import { MatchTag } from './MatchTag';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the claim way; each part uses its own slice of it */
import styles from './ClaimWay.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SuggestionMatchStripProps {
  match: CatalogSuggestionMatch;
  /** The name of the service whose link the merge adds, when the suggestion has one. */
  serviceName?: string;
}

/** The catalog row that a suggestion is the same song as (design catalog-merge c1). */
const SuggestionMatchStripComponent: React.FC<SuggestionMatchStripProps> = ({ match, serviceName }) => {
  const intl = useIntl();
  const isSure = match.confidence === CatalogSuggestionMatchConfidence.sure;
  const facts = [
    match.releaseDate === null ? null : formatCatalogDay(intl, match.releaseDate),
    serviceName === undefined ? null : intl.formatMessage(claimWayMessages.addsLink, { service: serviceName }),
  ].filter((fact): fact is string => fact !== null);

  return (
    <div className={clsx(styles.strip, !isSure && styles.stripPossible)} data-testid="suggestion-match">
      <Cover src={matchArtworkSrc(match.artworkUrl)} label={match.title} size={34} />
      <div>
        <span className={styles.stripTitle}>
          {intl.formatMessage(isSure ? claimWayMessages.matches : claimWayMessages.maybe, { title: match.title })}
        </span>
        {facts.length > 0 && <span className={styles.stripSub}>{facts.join(' · ')}</span>}
      </div>
      <MatchTag isSure={isSure} />
    </div>
  );
};

export const SuggestionMatchStrip = TypedMemo(SuggestionMatchStripComponent);
